import { Inject, Injectable, InjectionToken } from '@angular/core'

export const RECAPTCHA_SITE_KEY = new InjectionToken<string>('RECAPTCHA_SITE_KEY')

declare global {
  interface Window {
    grecaptcha: any
    recaptchaOnLoad?: () => void
  }
}

@Injectable({
  providedIn: 'root'
})
export class RecaptchaService {
  constructor(@Inject(RECAPTCHA_SITE_KEY) private siteKey: string) {}

  async execute(action: string): Promise<string> {
    if (!this.siteKey) {
      return ''
    }

    if (!window.grecaptcha?.enterprise) {
      throw new Error('grecaptcha.enterprise nao disponivel')
    }

    return window.grecaptcha.enterprise.execute(this.siteKey, { action })
  }
}

@Injectable({
  providedIn: 'root'
})
export class RecaptchaLoaderService {
  private loaded = false
  private promise?: Promise<void>

  constructor(@Inject(RECAPTCHA_SITE_KEY) private siteKey: string) {}

  init(): Promise<void> {
    if (!this.siteKey) {
      return Promise.resolve()
    }

    if (this.loaded) {
      return Promise.resolve()
    }

    if (this.promise) {
      return this.promise
    }

    this.promise = new Promise<void>((resolve, reject) => {
      const existing = document.querySelector<HTMLScriptElement>('script[data-recaptcha-enterprise]')

      if (existing && window.grecaptcha?.enterprise) {
        this.loaded = true
        resolve()
        return
      }

      window.recaptchaOnLoad = () => {
        if (window.grecaptcha?.enterprise) {
          this.loaded = true
          resolve()
          return
        }

        reject(new Error('grecaptcha.enterprise indisponivel'))
      }

      const script = document.createElement('script')
      script.src = `https://www.google.com/recaptcha/enterprise.js?onload=recaptchaOnLoad&render=${this.siteKey}`
      script.async = true
      script.defer = true
      script.setAttribute('data-recaptcha-enterprise', 'true')
      script.onerror = () => reject(new Error('Falha ao carregar reCAPTCHA Enterprise'))
      document.head.appendChild(script)
    })

    return this.promise
  }
}
